import { render } from "./AppGogoPoints.vue?vue&type=template&id=34e7881f&scoped=true"
import script from "./AppGogoPoints.vue?vue&type=script&lang=js"
export * from "./AppGogoPoints.vue?vue&type=script&lang=js"

import "./AppGogoPoints.vue?vue&type=style&index=0&id=34e7881f&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_b7c0161fc3875e000d6ad7ba26fe3ce3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34e7881f"]])

export default __exports__